var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMic = function SvgIcMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.834 8.333V10A5.833 5.833 0 0 1 10 15.833m0 0A5.833 5.833 0 0 1 4.167 10V8.333m5.833 7.5v3.334m-3.333 0h6.667M10 .833a2.5 2.5 0 0 0-2.5 2.5V10a2.5 2.5 0 1 0 5 0V3.333a2.5 2.5 0 0 0-2.5-2.5Z"
  })));
};
export default SvgIcMic;